import React from "react";
import classNames from "classnames";
import { GridTableRow } from "../../../../general/Tables/GridTable/GridTable";
import { Transaction } from "../../../../../common/types/transaction";
import { useIsDateLocked } from "../../../../../hooks/useIsDateLocked";
import { MatchingTransaction } from "./MatchingTransaction";
import styles from "./RuleTransactionsPreview.module.scss";

interface Props {
    transaction: Transaction;
    toggleTransaction: (transaction: Transaction) => void;
    excludedTransactionsIds: number[];
    applyToExistingTransactions: boolean;
}

export const RuleTransactionPreview: React.FC<Props> = ({
    transaction,
    toggleTransaction,
    excludedTransactionsIds,
    applyToExistingTransactions,
}) => {
    const isLocked = useIsDateLocked(transaction.entity.id, transaction.date);
    const disabled = isLocked || !applyToExistingTransactions;
    return (
        <GridTableRow
            className={classNames(styles.row, styles.bodyRow, {
                [styles.deselectedRow]:
                    excludedTransactionsIds.includes(transaction.id) ||
                    disabled,
            })}
        >
            <MatchingTransaction
                transaction={transaction}
                isChecked={
                    !disabled &&
                    !excludedTransactionsIds.includes(transaction.id)
                }
                isDisabled={disabled}
                toggle={toggleTransaction}
            />
        </GridTableRow>
    );
};
